import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.previewsMerge;

const previewsMergeData = createSelector([selector], (state) => state);

export default {
  previewsMergeData
};
